module.exports = __webpack_public_path__ + "img/logo-minus.19f298f7.png";